import Vue from 'vue'
import Vuex from 'vuex'
import questions from './questions'
import glossary from './glossary'
import inspirations from './inspirations'
import configurator from './configurator'
import pages from './pages'
import surveys from './surveys'
import blogs from './blogs'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        applications: [],
        technologies: []
    },
    modules: {
        questions,
        glossary,
        inspirations,
        configurator,
        pages,
        surveys,
        blogs
    },
    actions: {
        fetchData(context, payload){
            context.dispatch('configurator/fetchData', payload)
            context.dispatch('surveys/fetchData', payload)
            context.dispatch('inspirations/fetchData', payload)
            context.dispatch('questions/fetchData', payload)
            context.dispatch('glossary/fetchData', payload)
            context.dispatch('pages/fetchData', payload)
            context.dispatch('blogs/fetchData', payload)
        }
    }
})
